import axios from 'axios'
import { AES } from 'crypto-js'
import Vue from 'vue'
import Vuex from 'vuex'

import auth from '../store/auth'
import complaint from '../store/complaint'
import dialog from '../store/dialog'
import loading from '../store/loading'
import login from '../store/login'
import form from '../store/form'
import licenseForm from '../store/license_form'
import tradingForm from '../store/trading_form'
import tradingList from '../store/trading_list'
import metadata from '../store/metadata'
import reset from '../store/reset'
import search from '../store/search'
import snackbar from '../store/snackbar'
import feedback from '../store/feedback'
import pdf from '../store/pdf'
import history from '../store/history'
import ticket from '../store/ticket'

import i18n from '../i18n'
import configurations from '../configurations'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    complaint,
    dialog,
    loading,
    login,
    form,
    licenseForm,
    tradingForm,
    tradingList,
    metadata,
    reset,
    search,
    snackbar,
    feedback,
    pdf,
    history,
    ticket
  },
  actions: {
    sendSMS: async function (context, payload) {
      try {
        const body = {
          channel: payload.channel ? payload.channel : 'sms',
          recipient: payload.contact,
          message: payload.message,
          subject: payload.subject || 'MDKGU'
        }
        const key = configurations.AES_SECRET
        const ciphertext = AES.encrypt(JSON.stringify(body), key).toString()
        await axios.post(`/api/notify`, { message: btoa(ciphertext) }, {
          baseURL: 'https://sms.menggaris.com',
          withCredentials: false
        })
        this.dispatch('snackbar/setSnackBar', { color: 'success', message: i18n.t('sms_sent'), visible: true })
      } catch (error) {
        this.dispatch('snackbar/setSnackBar', {color: 'error', message: 'Failed to send sms verification', visible: true})
      }
    }
  }
})
